import { useCurrentClient } from '@pbk-web/state';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import TrainingService from '../services/TrainingService';

export const MY_TRAINING_PROGRAMS_QUERY_KEY = 'myTrainingPrograms';

/**
 * Ids of the programs the current user is a trainer on, within the current client.
 *
 * Trainer membership lives in a program's access policies and can change at any time (the user is
 * added to a program, or edits the policy themselves), so this is a cached read that is re-validated
 * on navigation — never a snapshot taken once at login.
 */
export const useMyTrainingPrograms = () => {
  const currentClient = useCurrentClient((x) => x.value);

  return useQuery({
    queryKey: [MY_TRAINING_PROGRAMS_QUERY_KEY, currentClient?.id],
    enabled: !!currentClient?.id,
    staleTime: 30 * 1000,
    queryFn: () => TrainingService.getMyTrainings().then((res) => res.data ?? []),
  });
};

/** Call after saving a program's members so trainer-gated UI (e.g. "Create event") updates at once. */
export const useInvalidateMyTrainingPrograms = () => {
  const queryClient = useQueryClient();

  return useCallback(() => queryClient.invalidateQueries({ queryKey: [MY_TRAINING_PROGRAMS_QUERY_KEY] }), [queryClient]);
};
